import React from "react";
import UFOCustomData from "@atlaskit/react-ufo/custom-data";
import { useExtensionInitTiming, ExtensionInitTimingData } from "../../hooks/useExtensionInitTiming";

/**
 * Component to add extension initialization timing data to UFO custom data
 * This should be rendered within a UFOSegment context to add the timing data
 * to the current segment's custom data
 */
export const ExtensionInitTimingUFO = (): React.JSX.Element | null => {
  const timingData: ExtensionInitTimingData | undefined = useExtensionInitTiming();

  if (!timingData) {
    return null;
  }

  const customData = {
    extensionScriptInitDuration: timingData.scriptInitDuration,
    extensionPageReadyDuration: timingData.pageReadyDuration,
    extensionInitStartTime: timingData.scriptInitStartTime,
    extensionInitEndTime: timingData.pageReadyEndTime,
    // Include iframe load timing data if available
    ...(timingData.iframeLoadDuration && {
      extensionIframeLoadDuration: timingData.iframeLoadDuration,
      extensionIframeLoadStartTime: timingData.iframeLoadStartTime,
      extensionIframeLoadEndTime: timingData.iframeLoadEndTime,
    }),
  };

  return <UFOCustomData data={customData} />;
};
